const _tp24 = window._tp24;

export default _tp24;
